export const GET_OPEN_AI_API_KEY_SLUG = `/api/config/key`;
export const GET_TEMPERATURE_SLUG =  `/api/config/temperature`;
export const GET_OPEN_AI_MODEL_SLUG =  `/api/config/openai-model`;